import { useCallback, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { listOverrideHistory } from '../api/plan-override-history-api'

export const HISTORY_QUERY_KEY = 'overrideHistory'
const DEFAULT_LIMIT = 20

export function useOverrideHistory(
  ruleId: string | undefined,
  ruleBase?: string
) {
  const [page, setPage] = useState(1)
  const [limit, setLimitState] = useState(DEFAULT_LIMIT)

  const setLimit = useCallback((newLimit: number) => {
    setLimitState(newLimit)
    setPage(1)
  }, [])

  const { data, isLoading, error, isFetching } = useQuery({
    queryKey: [HISTORY_QUERY_KEY, ruleId, page, limit, ruleBase],
    queryFn: () => listOverrideHistory(ruleId ?? '', { page, limit }, ruleBase),
    enabled: !!ruleId,
    placeholderData: (prev) => prev,
  })

  const total = data?.meta.total ?? 0
  const totalPages = total > 0 ? Math.ceil(total / limit) : 0

  return {
    entries: data?.data ?? [],
    total,
    totalPages,
    page,
    limit,
    isLoading,
    isFetching,
    error,
    goToPage: setPage,
    setLimit,
    loadMore: () => setPage((prev) => prev + 1),
    hasMore: page < totalPages,
  }
}
